<template lang="pug">
  nav.site-nav-wrap.xs-12(:class="{ open: siteNavMobileNavOpen }")
    template(v-if="showMobileNav")
      SiteNavMobileV2(
        :shop-nav="dynamicShopNav"
        :nav-items="dynamicNavItems"
        :nav-links="dynamicNavLinks"
        :about-nav="aboutNavExtraConfig"
      )
    template(v-else)
      SiteNavDesktopV2(
        :shop-nav="dynamicShopNav"
        :nav-items="dynamicNavItems"
        :nav-links="dynamicNavLinks"
        :about-nav="aboutNavExtraConfig"
      )

</template>

<script>
  import { mapGetters, mapState, mapActions } from "vuex";
  import SiteNavDesktopV2 from "@components/SiteNav/SiteNavDesktopV2";
  import SiteNavMobileV2 from "@components/SiteNav/SiteNavMobileV2";

  export default {
    name: "SiteNav",

    components: {
      SiteNavDesktopV2,
      SiteNavMobileV2,
    },

    computed: {
      ...mapGetters('customer', [
        'isCustomerPresent',
      ]),

      ...mapState('global', ['isVueSSRApp']),

      ...mapState('siteNav', [
        'siteNavMobileNavOpen',
        'dynamicShopNav',
        'dynamicNavItems',
        'dynamicNavLinks',
        'aboutNavExtraConfig',
      ]),

      ...mapState('global', [
        'windowData'
      ]),

      showMobileNav() {
        const { breakpoint } = this.windowData;
        return !['desktop', ''].includes(breakpoint);
      },
    },

    async created() {
      if (!this.isVueSSRApp) {
        await this.loadDynamicNav();
      }
    },

    methods: {
      ...mapActions('siteNav', [
        'loadDynamicNav',
      ]),
    },

    async serverPrefetch() {
      if (this.isVueSSRApp) {
        await this.loadDynamicNav();
      }
    }
  };
</script>

<style scoped lang="stylus">
  @media mq-desktop-md-less
    nav.site-nav-wrap
      position fixed
      right 0
      top 0
      bottom 0
      display flex
      align-self flex-start
      flex-direction column
      left 0
      transform translateX(-100%)
      transition(transform 0.3s ease-in-out)
      background-color color-white

      &.open
        transform none
        transition(transform 0.3s ease-in-out)

      .site-nav-item
      .site-nav-title
        width 100%
        display block
        text-align left

      #extole_zone_global_header
        display inline-block

</style>
